import { FallbackProps } from 'react-error-boundary';
import { FormattedMessage } from 'react-intl';
import WarningIcon from '../../assets/icons/warning.svg?react';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { CardTitle } from '../../components/CardTitle';
import styles from './Main.module.css';
import { Row } from '../../components/Flex/Row';
import { Col } from '../../components/Flex/Col/Col';

export function currentStatusfallbackRender({
  resetErrorBoundary,
}: FallbackProps) {
  return (
    <Card>
      <CardTitle>
        <FormattedMessage id="CurrentStatus" />
      </CardTitle>
      <Col>
        <Row>
          <WarningIcon className={styles.errorIcon} />
          <FormattedMessage tagName="div" id="Logbook.StatusError" />
        </Row>
        <Button onClick={resetErrorBoundary} variant="text">
          <FormattedMessage id="Retry" />
        </Button>
      </Col>
    </Card>
  );
}
